export default function SubTitle({ title }) {
  return (
    <div className="flex justify-center py-4">
      <h3 className="relative px-4 py-1.5 text-base font-normal capitalize text-portfolio-title before:absolute before:bottom-0 before:left-0 before:h-px before:w-full before:bg-subtitle-divider before:content-['']">
        {title}
      </h3>
    </div>
  );
}
